import React from "react";

// eslint-disable-next-line import/prefer-default-export
export const Bodywash = (): React.ReactNode => (
  <svg
    viewBox="0 0 24 24"
    width="20px"
    height="20px"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Soap bar */}
    <rect x="4" y="8" width="16" height="10" rx="5" fill="currentColor" />

    {/* Highlight (shine) */}
    <path d="M8 11C9.5 9.8 12 9.8 13.5 11" stroke="white" strokeWidth="0.8" strokeLinecap="round" />
  </svg>
);
